import { useEffect } from "react";
import { getPlans } from "../LandingPage";

export function useCheckoutPlan() {
    const urlParams = new URLSearchParams(window.location.search);
    const planId = urlParams.get('plan');
    const plans = getPlans();
    const plan = plans.find((p) => p.id === planId);
  
    useEffect(() => {
      if (!plan || plan.isOneTime) {
        window.location.href = "/results";
      }
    }, [plan]);

    return plan;
}